/**
 * @generated SignedSource<<239dd6a94e28f730c916b6e5c524ccf0>>
 * @relayHash 8dc51dcb846862aa9c8f8929ac2aebfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 53d89db9d85056eef82787d8d31a7893b60114ad98b36ee3758ba073330b2852

import type { ConcreteRequest } from 'relay-runtime';
export type useConfluenceStandardToPremiumExperimentQuery$variables = {
  key?: ReadonlyArray<string | null> | null;
};
export type useConfluenceStandardToPremiumExperimentQuery$data = {
  readonly isSiteAdmin: boolean | null;
  readonly license: {
    readonly firstPredunningEndTime: AGG$Long | null;
    readonly trialEndDate: string | null;
  } | null;
  readonly onboardingState: ReadonlyArray<{
    readonly key: string;
    readonly value: string | null;
  }> | null;
};
export type useConfluenceStandardToPremiumExperimentQuery = {
  response: useConfluenceStandardToPremiumExperimentQuery$data;
  variables: useConfluenceStandardToPremiumExperimentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      }
    ],
    "concreteType": "OnboardingState",
    "kind": "LinkedField",
    "name": "onboardingState",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  },
  {
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "license",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "trialEndDate"
      },
      {
        "kind": "ScalarField",
        "name": "firstPredunningEndTime"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConfluenceStandardToPremiumExperimentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfluenceStandardToPremiumExperimentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8dc51dcb846862aa9c8f8929ac2aebfd",
    "id": "53d89db9d85056eef82787d8d31a7893b60114ad98b36ee3758ba073330b2852",
    "metadata": {},
    "name": "useConfluenceStandardToPremiumExperimentQuery",
    "operationKind": "query",
    "text": "query useConfluenceStandardToPremiumExperimentQuery($key:[String]){isSiteAdmin,onboardingState(key:$key){key,value},license{trialEndDate,firstPredunningEndTime}}"
  }
};
})();

(node as any).hash = "3dcc62a6c345897ba2c1f5872f6a9096";

export default node;
